import { useState } from "react";
import { Loader2, X } from "lucide-react";
import { formatDate } from "../../utils/examsschedule/examHelpers";

/**
 * Date changes must use postpone API (newDate + optional reason).
 * Never send examDate via schedule update.
 */
export default function PostponeScheduleModal({
  schedule,
  onClose,
  onSubmit,
  submitting = false,
}) {
  const [newDate, setNewDate] = useState("");
  const [reason, setReason] = useState("");
  const [localError, setLocalError] = useState("");

  if (!schedule) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setLocalError("");
    if (!newDate) {
      setLocalError("New exam date is required");
      return;
    }
    onSubmit?.({
      newDate,
      reason: reason.trim() || "",
    });
  };

  const inputCls =
    "border border-gray-300 dark:border-neutral-700 rounded-lg px-3 py-2 text-sm w-full focus:outline-none focus:ring-2 focus:ring-indigo-500";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white dark:bg-neutral-900 rounded-xl shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h3 className="text-sm font-semibold text-gray-800 dark:text-neutral-100">
            Postpone schedule
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 dark:text-neutral-500 hover:text-gray-700"
            disabled={submitting}
          >
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <p className="text-xs text-gray-500 dark:text-neutral-400">
            <span className="font-medium text-gray-700 dark:text-neutral-200">
              {schedule.subjectId?.name || "Subject"} ·{" "}
              {schedule.classId?.className || "Class"}
            </span>
            <br />
            Current date:{" "}
            <span className="font-medium">{formatDate(schedule.examDate)}</span>
          </p>

          {localError && (
            <p className="text-xs text-red-600 bg-red-50 rounded-lg px-3 py-2">
              {localError}
            </p>
          )}

          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-neutral-400 mb-1">
              New exam date *
            </label>
            <input
              type="date"
              className={inputCls}
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
              required
              disabled={submitting}
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-neutral-400 mb-1">
              Reason (optional)
            </label>
            <input
              className={inputCls}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="e.g. Holiday / clash"
              disabled={submitting}
            />
          </div>

          <div className="flex gap-2 justify-end pt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="border text-sm px-4 py-2 rounded-lg text-gray-600 dark:text-neutral-300 hover:bg-gray-50 dark:hover:bg-neutral-800"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="inline-flex items-center gap-2 bg-orange-600 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-orange-700 disabled:opacity-50"
            >
              {submitting && <Loader2 size={14} className="animate-spin" />}
              Postpone
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
